<span class="credits-ring" [class]="'credits-ring level-' + level" [style.width.px]="size" [style.height.px]="size">
  <svg [attr.viewBox]="'0 0 ' + size + ' ' + size" [attr.width]="size" [attr.height]="size" aria-hidden="true">
    <circle
      class="credits-ring-track"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
      [attr.r]="radius"
      [attr.stroke-width]="stroke"
    />
    <circle
      class="credits-ring-value"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
      [attr.r]="radius"
      [attr.stroke-width]="stroke"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset"
      [attr.transform]="'rotate(-90 ' + size / 2 + ' ' + size / 2 + ')'"
    />
  </svg>
  <!-- An icon, not the number: "92%" inside the ring was ambiguous (used
       or left?) and didn't fit at 100%. The count is shown as text next to
       the ring by the host (e.g. "46 left"). -->
  <i class="bi bi-stars credits-ring-icon" aria-hidden="true"></i>
</span>
